const { REACT_APP_PROD_URL } = process.env

const isProd = window.location.hostname === `${REACT_APP_PROD_URL}`

export { isProd }
